import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Redirect } from 'react-router-dom'

export class ColHead extends React.Component {

	render() {
		return (
			<div className="col__head">
			    {this.props.icon && (<FontAwesomeIcon className="col__icon" icon={this.props.icon} />)} 
				<h2 className="col__title">{this.props.title}</h2>
			    {this.props.meta && <span className="col__meta">{this.props.meta}</span>}
			</div>
      	)
	}
};

export class ColError extends React.Component {

	render() {

		const {error, errors} = this.props;

		//@debug
		if(error) console.error(error.message);
		//if(error?.networkError?.result?.errors) {
		if(error && error.networkError) {
			if(error.networkError.result && error.networkError.result.errors) {
				error.networkError.result.errors.forEach(e => {
					console.error(e.message);
				})
			}

			if(error.networkError.statusCode === 401) {
				return (<Redirect to="/login" />)
			}
		}

		return (
			<div className="container">
				<div className="centered">
					<div className="col__error">
					    <FontAwesomeIcon className="col__icon" icon="exclamation-triangle" />
					    {error && (<p>{error.message}</p>)}
					    {errors && errors.map(error => <p>{error.message}</p>)}
						{/*networkError && networkError.result && networkError.result.errors && networkError.result.errors.map((error, i) => <p key={`error-${i}`}>{error.message}</p>)*/}
					    {/*networkError && networkError.errors.map(error => <p>{error.message}</p>)*/}
					    {(!error && !errors) && (<p>Hmm, something went wrong.</p>)}
					</div>
				</div>
			</div>
      	)
	}
};

export class ColLoading extends React.Component {

	render() {
		return (
			<div className="col__head col__head--loading">
			    <FontAwesomeIcon className="col__icon fa-pulse" icon="spinner" /> 
				<h2 className="col__title">LOADING</h2>
			</div>
      	)
	}
};


// WEBPACK FOOTER //
// ./src/components/chunk/Column.js